export default __webpack_public_path__ + "static/backgroundChampion-f85c35ae4f3248d2077bec0206ecec7d.png";